<template>
  <div v-if="open" class="mask" @click.self="$emit('close')">
    <div class="sheet">
      <div class="head">
        <div>
          <strong>{{ nickname }}</strong>
          <p class="meta">{{ email }}</p>
        </div>
        <button type="button" class="x" @click="$emit('close')">关闭</button>
      </div>
      <p v-if="balances" class="bal">积分 {{ balances.points }} · Token {{ balances.tokens }}</p>
      <p v-if="loading" class="muted">加载流水…</p>
      <p v-else-if="error" class="err">{{ error }}</p>
      <ul v-else-if="rows.length" class="list">
        <li v-for="row in rows" :key="row.id">
          <span class="when">{{ formatLedgerTime(row.created_at) }}</span>
          <span class="act">{{ actionLabel(row.action) }}</span>
          <span class="delta" :class="{ plus: row.delta > 0, minus: row.delta < 0 }">
            {{ row.delta > 0 ? '+' : '' }}{{ row.delta }}
          </span>
          <span class="after">余 {{ row.balance_after }}</span>
        </li>
      </ul>
      <p v-else class="muted">暂无积分记录</p>
      <router-link class="more" to="/account" @click="$emit('close')">我的</router-link>
    </div>
  </div>
</template>

<script>
import { billingLedger } from '../api/platformService'
import { actionLabel, formatLedgerTime } from '../utils/ledgerLabels'

export default {
  name: 'CreditsPopover',
  props: {
    open: { type: Boolean, default: false },
    nickname: { type: String, default: '' },
    email: { type: String, default: '' },
    balances: { type: Object, default: null }
  },
  emits: ['close'],
  data() {
    return { rows: [], loading: false, error: '' }
  },
  watch: {
    open: {
      immediate: true,
      handler(val) {
        if (val) this.load()
      }
    }
  },
  methods: {
    actionLabel,
    formatLedgerTime,
    async load() {
      this.loading = true
      this.error = ''
      try {
        this.rows = await billingLedger()
      } catch (err) {
        this.error = err.response?.data?.error || '加载失败'
        this.rows = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.mask {
  position: fixed;
  inset: 0;
  z-index: 80;
  background: rgba(29, 33, 41, 0.28);
  display: flex;
  justify-content: flex-end;
  padding: 64px 16px 16px;
}
.sheet {
  width: min(420px, 100%);
  max-height: calc(100vh - 88px);
  overflow: auto;
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 12px 40px rgba(29, 33, 41, 0.12);
  align-self: flex-start;
}
.head {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
}
.head strong { font-size: 16px; }
.meta { margin: 4px 0 0; color: #86909c; font-size: 12px; }
.x {
  border: 1px solid #e5e6eb;
  background: #fff;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  color: #4e5969;
}
.bal { margin: 10px 0; color: #165dff; font-weight: 600; }
.list { list-style: none; margin: 0; padding: 0; }
.list li {
  display: grid;
  grid-template-columns: 1.2fr 1fr auto auto;
  gap: 8px;
  font-size: 12px;
  padding: 8px 0;
  border-top: 1px solid #f2f3f5;
}
.when, .act, .after { color: #4e5969; }
.plus { color: #00b42a; font-weight: 600; }
.minus { color: #f53f3f; font-weight: 600; }
.muted { color: #86909c; font-size: 13px; }
.err { color: #f53f3f; font-size: 13px; }
.more {
  display: inline-block;
  margin-top: 12px;
  color: #165dff;
  text-decoration: none;
  font-size: 13px;
}
@media (max-width: 640px) {
  .list li { grid-template-columns: 1fr 1fr; }
  .after { display: none; }
}
</style>
